<template>
  <HomeLayout class="h-full text-center">
    <div class="flex items-center w-full h-full">
      <div class="w-full">
        <BaseImg src="/char-hu-1.png" class="mx-auto" />

        <h1 class="my-10 text-2xl font-bold text-white sm:text-4xl">
          <template v-if="resource">
            {{ resource }}
          </template>
          잘못 들어오셨어요!
        </h1>

        <router-link :to="{ name: 'home' }">
          <button class="px-5 py-2 text-2xl font-bold text-white bg-gray-700 rounded sm:text-4xl">홈으로</button>
        </router-link>
      </div>
    </div>
  </HomeLayout>
</template>

<script>
import HomeLayout from '@layouts/home-layout.vue'

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { HomeLayout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>
